<template>
	<div class="account-settings-info-view">
		<div class="back">
			<img class="base_img" src="../../../assets/image/base_img.png" alt="">
			<div class="userInfo">
				<div class="item">
					<span style="font-weight: 600;">头像：</span>
					<span style="color: darkgray;font-weight: 600;">
						<div class="ant-upload-preview" @click="$refs.modal.edit(1)">
							<!-- <a-icon type="cloud-upload-o" class="upload-icon" /> -->
							<div class="mask">
								<a-icon type="plus" />
							</div>
							<img :src="imgsrc" />
						</div>
					</span>

				</div>
				<div class="item">
					<span style="font-weight: 600;">姓名：</span><span style="color: darkgray;font-weight: 600;">{{
							this.$store.getters.userInfo.userName
					}}</span>
				</div>
				<div class="item">
					<span style="font-weight: 600;">登录名：</span><span style="color: darkgray;font-weight: 600;">{{
							this.$store.getters.userInfo.loginName
					}}</span>
				</div>
				<div class="item">
					<span style="font-weight: 600;">所属公司：</span><span style="color: darkgray;font-weight: 600;">{{
							this.$store.getters.userInfo.company
					}}</span>
				</div>
				<div class="item">
					<span style="font-weight: 600;">所属部门：</span><span style="color: darkgray;font-weight: 600;">{{
							this.$store.getters.userInfo.dept.deptName
					}}</span>
				</div>
				<div class="item">
					<span style="font-weight: 600;">部门主管：</span><span style="color: darkgray;font-weight: 600;">{{
							this.$store.getters.userInfo.dept.leader
					}}</span>
				</div>
				<div class="item">
					<span style="font-weight: 600;">邮箱：</span><span style="color: darkgray;font-weight: 600;">{{
							this.$store.getters.userInfo.email
					}}</span>
				</div>
				<a-button type="primary" shape="round" @click="change" style="margin-top:8px;">修改密码</a-button>
			</div>

		</div>

		<a-modal title="修改密码" :visible="visible" @ok="primary" @cancel="handleCancel">
			<a-form :form="form">
				<a-form-item label="原密码">
					<a-input-password size="large" placeholder="请输入原密码" v-decorator="[
						'password',
						{
							rules: [{ required: true, message: '请输入原密码' }],
							validateTrigger: 'blur',
						},
					]">
						<a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
					</a-input-password>
				</a-form-item>
				<a-form-item label="新密码">
					<a-input-password size="large" placeholder="请输入新密码" v-decorator="[
						'newPassword',
						{
							rules: [{ required: true, message: '请输入新密码' },
							{ min: 6, message: '密码不得小于6位！' }],
							validateTrigger: 'blur',
						},
					]">
						<a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
					</a-input-password>
				</a-form-item>
				<a-form-item label="确认密码">
					<a-input-password size="large" placeholder="请确认新密码" v-decorator="[
						'Password',
						{
							rules: [{ required: true, message: '请再次输入密码' }],
							validateTrigger: 'blur',
						},
					]">
						<a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
					</a-input-password>
				</a-form-item>
			</a-form>
		</a-modal>
		<avatar-modal ref="modal" @ok="setavatar" />
	</div>
</template>

<script>
import AvatarModal from './AvatarModal'
import {
	modify_pwd
} from '@/api/assetmenag'
import {
	mapActions
} from 'vuex'
export default {
	components: {
		AvatarModal
	},
	data() {
		return {
			// cropper
			preview: {},
			form: this.$form.createForm(this),
			visible: false,
			imgsrc: process.env.VUE_APP_API_BASE_URL + '/file/file/pre_file?bucketName=avatar&path=/' + this.$store.getters.avatar,
			option: {
				img: '/avatar2.jpg',
				info: true,
				size: 1,
				outputType: 'jpeg',
				canScale: false,
				autoCrop: true,
				// 只有自动截图开启 宽度高度才生效
				autoCropWidth: 180,
				autoCropHeight: 180,
				fixedBox: true,
				// 开启宽度和高度比例
				fixed: true,
				fixedNumber: [1, 1],
				hasSelectedAssert: false,
			}
		}
	},
	created() {

	},
	mounted() {
		// this.imgsrc = this.$store.getters.userInfo.avatar
	},
	methods: {
		...mapActions(['Logout']),
		setavatar(url) {
			console.log(url)
			this.option.img = url
		},
		change() {
			this.visible = true
		},
		handleCancel() {
			this.visible = false
		},
		primary() {
			this.form.validateFields((err, values) => {
				if (values['Password'] != values['newPassword']) {
					this.$message.warning('两次密码输入不一致！')
				} else {
					if (!err) {
						values['userId'] = this.$store.getters.userInfo.userId
						values['loginName'] = this.$store.getters.userInfo.loginName
						delete values['Password']
						modify_pwd(values)
							.then((res) => {
								if (res.code === 200) {
									this.$message.success(res.msg)
									this.$emit('ok')
									return this.Logout({})
										.then(() => {
											setTimeout(() => {
												this.$router.push({
													name: 'login',
												})
											}, 16)
										})
										.catch((err) => {
											this.$message.error({
												title: '错误',
												description: err.message,
											})
										})
								} else {
									this.$message.warning(res.msg)
								}
							})
							.catch(() => {
								this.$message.error('系统错误，请稍后再试')
							})
					}
				}
			})
		}
	}
}
</script>

<style lang="less" scoped>
.account-settings-info-view {
	width: 100%;
	height: 100%;
	float: left;
	box-sizing: border-box;
	padding-bottom: 15px;
	box-sizing: border-box;

	.back {
		width: 100%;
		height: 100%;
		border-radius: 10px;
		background: #1890ff0f;
		position: relative;

		.base_img {
			position: absolute;
			right: 0;
			bottom: 0;
			width: 40%;
		}

		.userInfo {
			width: 30%;
			display: flex;
			float: left;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			margin-left: 10%;
			margin-top: 50px;
			.item {
				margin-bottom: 24px;
				width: 100%;
				display: flex;
				justify-content: space-between;
				align-items: center;
			}
		}
	}
}

.avatar-upload-wrapper {
	height: 200px;
	width: 100%;
}

.ant-upload-preview {
	position: relative;
	margin: 0 auto;
	width: 100px;
	height: 100px;
	border-radius: 20px;
	overflow: hidden;
	box-shadow: 0 0 4px #ccc;

	.upload-icon {
		position: absolute;
		top: 0;
		right: 10px;
		font-size: 1.4rem;
		padding: 0.5rem;
		background: rgba(222, 221, 221, 0.7);
		border-radius: 50%;
		border: 1px solid rgba(0, 0, 0, 0.2);
	}

	.mask {
		opacity: 0;
		position: absolute;
		background: rgba(0, 0, 0, 0.4);
		cursor: pointer;
		transition: opacity 0.4s;

		&:hover {
			opacity: 1;
		}

		i {
			font-size: 2rem;
			position: absolute;
			top: 50%;
			left: 50%;
			margin-left: -1rem;
			margin-top: -1rem;
			color: #d6d6d6;
		}
	}

	img,
	.mask {
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
}



.item_t {
	width: 100%;
	float: left;
	height: 45px;
	margin-bottom: 20px;
	display: flex;
	justify-content: center;
	align-items: center;

	.block {
		width: 5px;
		height: 24px;
		background: #2479e2;
		margin-right: 15px;
	}

	span {
		font-size: 16px;
		font-weight: 600;
	}
}
</style>
